import { useContext } from "react";

import { useTranslation } from "react-i18next";

import TableContext from "context/table/tableContext";

import RegularHeader from "../components/RegularHeader";

export const CompanyHeader = () => {
    const { detailsData } = useContext(TableContext);

    const { t } = useTranslation();

    const { name, company } = detailsData;

    return (
        <RegularHeader
            titleValue={name}
            subtitleName={t(`Table##parent company`)}
            subtitleValue={
                company ? company.name : t("Table##no parent company")
            }
        />
    );
};

export default CompanyHeader;
